import { getNamespaces, getConfig } from './getNamespaces';
import { createTranslation } from './utils';
import { cache } from 'react';

export const getTranslationsForLocale = cache(async (locale: string, namespace?: string) => {
  const config = await getConfig();
  const defaultNS = namespace ?? config.defaultNS ?? 'common';
  const namespaces = await getNamespaces(locale);
  return {
    t: cache(createTranslation(namespaces[defaultNS])),
  };
});
